// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — page-main-view.classic.js, новая — page-main-view.cp.js
import { isCp } from 'libs/design';
import * as classic from './page-main-view.classic';
import * as cp from './page-main-view.cp';

export const PageMainView = isCp ? cp.PageMainView : classic.PageMainView;
